import { put, takeLatest, call } from "redux-saga/effects";
import * as memberAction from "../../actions/ActionCreator";
import * as memberType from "../../actions/ActionType";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";
import * as Api from "../../../appApi/AppApi";

const TAG = "carrierGetSubmittedBrands.js";

function* workerCarrierGetSubmittedBrands(payLoad) {
  console.log(TAG, "get submitted brands : " + JSON.stringify(payLoad));
  try {
    const response = yield call(
      Api.makeSecuredPostRequest,
      API_ENDPOINT.GET_SUBMITTED_BRANDS
    );
    yield put(memberAction.carrierGetSubmittedBrandsSuccess(response));
  } catch (error) {
    console.error(TAG, "Worker get submitted brands failed: " + error.message);
    // yield put(memberAction.deleteUserFailed(error.message));
    // throw new Error("Error: inside saga", JSON.stringify(error));
  }
}

export const watchCarrierGetSubmittedBrands = takeLatest(
  memberType.CARRIER_GET_SUBMITTED_BRANDS_REQESTED,
  workerCarrierGetSubmittedBrands
);
